/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza. [cite: 24, 116]
 */

import emailRegex from 'email-regex';

/**
 * React Query state names.
 */
export const ME_QUERY_NAME = 'me';
export const HUMAN_RESOURCES_QUERY_NAME = 'human-resources';
export const HUMAN_RESOURCE_QUERY_NAME = 'human-resource';
export const JOB_POSTS_QUERY_NAME = 'job-posts';
export const JOB_POST_QUERY_NAME = 'job-post';

/**
 * Regular expressions for data validation.
 */

/**
 * Email validation regex (standardized and tested).
 */
export const emailRegExpr = emailRegex({ exact: true });

/**
 * Date validation regex (YYYY-MM-DD).
 */
export const dateRegExpr = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;

/**
 * Italian VAT number (Partita IVA) regex.
 */
export const pivaRegExpr = /^[0-9]{11}$/;

/**
 * Italian Fiscal Code (Codice Fiscale) regex.
 */
export const taxCodeRegExpr =
  /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|^([0-9]{11})$/;

/**
 * Phone number validation regex.
 */
export const phoneRegExpr = /^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{4,10}$/;

/**
 * Italian Postal Code (CAP) regex.
 */
export const capRegExpr = /^[0-9]{5}$/;

/**
 * ATECO code validation regex.
 */
export const atecoRegExpr = /^[0-9.]+$/;

/**
 * Subscription and Credit constants.
 */
export const CREDITS = 1;
export const CREDITS_SMART = 9;
export const CREDITS_MEMBERSHIP = 10;

export const ALERT_DB_12 = 3;
export const ALERT_NP_12 = 4;

export const JOB_POSTING_12 = 5;

export const CREDITS_1 = 8;
export const CARD_BRAND = 11;

export const SUCCESS_CARD = 12;

/**
 * Labels for subscription types.
 */
export const SUBSCRIPTIONS_LABELS: Record<number, string> = {
  1: 'Card Crediti',
  2: 'Smart Card',
  3: 'Alert Database',
  4: 'Alert New Profile 12 Mesi',
  5: 'Offerte di lavoro 12 Mesi',
  6: 'HR Membership Card',
  7: 'APL Card',
  8: 'Card Crediti 1',
  9: 'Card Crediti 5',
  10: 'Card Crediti 10',
};

/**
 * Standard date format for the application.
 */
export const DATE_FORMAT = 'DD/MM/YYYY';
